"use client";

import _objectSpread from "D:\\PROJECT_WORK\\Excitr + SCHelper 2023-20240417T143946Z-001 (1)\\Excitr + SCHelper 2023\\web_sch-2.0.1 copy\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "D:\\PROJECT_WORK\\Excitr + SCHelper 2023-20240417T143946Z-001 (1)\\Excitr + SCHelper 2023\\web_sch-2.0.1 copy\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var Container =
/*#__PURE__*/
React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      _ref$fluid = _ref.fluid,
      fluid = _ref$fluid === void 0 ? false : _ref$fluid,
      _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["bsPrefix", "fluid", "as", "className"]);

  var prefix = useBootstrapPrefix(bsPrefix, 'container');
  var suffix = typeof fluid === 'string' ? "-".concat(fluid) : '-fluid';
  return (
    /*#__PURE__*/
    _jsx(Component, _objectSpread({
      ref: ref
    }, props, {
      className: classNames(className, fluid ? "".concat(prefix).concat(suffix) : prefix)
    }))
  );
});
Container.displayName = 'Container';
export default Container;